<template>
  <div>
	<navbar :hasSearch="true" />
	<div id="content">
	<div class="row">
	<div class="col-md-6 pb-3">
		<div class="card h-100">
		<ol class="breadcrumb lighten-4 my-auto">
			<li class="breadcrumb-item">
			<router-link :to="{ name: 'landingPage' }">
				<a class="black-text" href="#">Home</a>
			</router-link>
			<i class="fa fa-angle-right mx-2" aria-hidden="true"></i>
			</li>
			<li class="breadcrumb-item active font-weight-bold">
			DD Payment Failure Charges
			<i class="fa fa-angle-right mx-2" aria-hidden="true"></i>
			</li>
		</ol>
		</div>
	</div>
	<quick-links></quick-links>
	</div>

	<div class="content_body">
	<div class="container-fluid no-pad">
		<div class="border border-light rounded bg-white brs my-3 pl-3 pr-3">
		<div class="row mt-3 mb-3">
			<div class="col-12">
			<h4 class="d-inline">DD Payment Failure Charges</h4>
			<div class="d-inline ml-2 my-auto">
				<a @click="fetchCharges" href="#">
				<img
					src="@/assets/img/refresh_icon.png"
					class="mb-2"
					alt="Refesh Icon"
				/>
				</a>
			</div>
			</div>
			</div>
			<div class="table-responsive-lg">
			<b-table
				id="dd-charges-table"
				striped
				responsive
				hover
				:items="combinedCharges"
				:fields="fields"
				:busy="loading"
				:current-page="currentPage"
				:per-page="perPage"
				primary-key="Code"
			>
			<template v-slot:table-busy>
				<b-row align-h="center">
				<propagate-loader
					class="mb-3"
					:size="16"
				></propagate-loader>
				</b-row>
			</template>
			<template slot="Amount" slot-scope="row">
				<div class="d-flex w-100">
					<div class="col-11">{{row.item.Amount | currency}}</div>
					<i v-if="!row.detailsShowing" class="float-right pointer fas fa-edit mt-1 mx-2" @click="toggleEditMode(true, row)"></i>
				</div>
			</template>
			<template v-slot:row-details="row">
				<b-card>
					<div class="row">
						<div class="col-12 col-lg-6">
							<div class="row">
								<div class="col-md-4">
									<p class="font-weight-bold">Amount:</p>
								</div>
								<div class="col-md-8">
									<div class="input-group">
										<div class="input-group-prepend">
											<span class="input-group-text">£</span>
										</div>
										<input type="number" class="form-control" v-model.number="editedAmount" />
									</div>
								</div>
							</div>
						</div>
					</div>

					<hr class="mt-2" />

					<div class="row">
						<div class="col-12">
							<div>
								<div class="text-left float-right">
									<b-btn @click="toggleEditMode(false, row)" class="btn btn-danger mr-1">Cancel</b-btn>
									<b-btn @click="saveChanges(row)" class="btn btn-success ml-1">Save Changes</b-btn>
								</div>
							</div>
						</div>
					</div>
				</b-card>
			</template>
			<template slot="actions" slot-scope="data">
				<button
					class="btn"
					style="width: 6em"
					:class="data.item.Enabled ? 'btn-success' : 'btn-danger'"
					@click.prevent="toggleEnabled(data.item)"
					:disabled="!data.item.Amount"
				>
					{{ data.item.Enabled ? 'Enabled' : 'Disabled' }}
				</button>
			</template>
			</b-table>
		</div>
	<hr />
	<div class="container-fluid no-pad">
	<div class="d-flex overflow-auto my-3">
		<b-pagination
		class="my-auto d-flex justify-content-center align-items-center mx-auto"
		v-model="currentPage"
		:total-rows="combinedCharges.length"
		:per-page="perPage"
		aria-controls="charges_table"
		@input="scrollToTop()"
		>
		<template v-slot:first-text>
			<i class="fas fa-angle-double-left fa-2x pointer"></i>
		</template>
		<template v-slot:prev-text>
			<i class="fas fa-chevron-left fa-2x pointer"></i>
		</template>
		<template v-slot:next-text>
			<i class="fas fa-chevron-right fa-2x pointer"></i>
		</template>
		<template v-slot:last-text>
			<i class="fas fa-angle-double-right fa-2x pointer"></i>
		</template>
		</b-pagination>
	</div>
	</div>
		</div>
	</div>
	</div>
	</div>
  </div>
</template>

<script>
import Navbar from '@/components/Navbar.vue';
import QuickLinks from '@/components/QuickLinks.vue';
import _filters from '@/mixins/filters';

export default {
	name: 'FailedDdPaymentCharges',
	mixins: [_filters],
	components: {
		Navbar,
		QuickLinks,
	},
	data() {
		return {
			perPage: 10,
			currentPage: 1,
			submitStatus: null,
			beforeEditingCharge: null,
			editedAmount: null,
			fields: [
				{ key: 'Description', label: 'Charge Type', sortable: true },
				{
					key: 'Code',
					label: 'ARUDD Code',
					sortable: true,
					class: 'text-center',
				},
				{
					key: 'Amount',
					label: 'Amount',
					sortable: true,
					class: 'text-center',
				},
				{ key: 'actions', label: 'Actions', class: 'text-right' },
			],
		};
	},
	computed: {
		aruddCodes() {
			return this.$store.state.finances.aruddCodes;
		},
		ddCharges() {
			return this.$store.state.finances.ddCharges;
		},
		combinedCharges() {
			return this.aruddCodes.map((code) => {
				const charge = this.ddCharges.find((c) => c.Code === code.Code);
				return {
					...code,
					...charge,
				};
			});
		},
		loading() {
			return (
				this.$store.state.finances.aruddCodesLoading ||
				this.$store.state.finances.ddChargesLoading
			);
		},
	},
	methods: {
		scrollToTop() {
			document.getElementById('dd-charges-table').scrollIntoView();
		},
		fetchCharges() {
			this.$store.dispatch('getAruddCodes');
			this.$store.dispatch('getDdCharges');
		},
		toggleEnabled(charge) {
			if (!charge.Amount) {
				this.$snotify.error(
					'Please edit the charge and set an amount before enabling or disabling it.'
				);
				return;
			}
			this.$store
				.dispatch('updateDdCharge', { ...charge, Enabled: !charge.Enabled })
				.then(() => {
					this.$snotify.success('Charge updated successfully!');
				})
				.catch(() => {
					this.$snotify.error('Error updating charge.');
				});
		},
		toggleEditMode(bool, row) {
			if (bool && !this.editMode) {
				this.beforeEditingCharge = Object.assign({}, row.item);
				this.editedAmount = row.item.Amount;
				this.editMode = true;
				row.toggleDetails();
			} else if (!bool && this.editMode) {
				if (!this.beforeEditingCharge.hasOwnProperty('Amount')) {
					row.item.Amount = null;
				}
				Object.assign(row.item, this.beforeEditingCharge);
				this.editedAmount = null;
				this.editMode = false;
				row.toggleDetails();
			}
		},
		saveChanges(row) {
			var charge = row.item;
			charge.Amount = this.editedAmount;
			this.submitStatus = 'PENDING';
			this.$store
				.dispatch('updateDdCharge', charge)
				.then(() => {
					this.$snotify.success('Charge updated successfully!');
					this.beforeEditingCharge = null;
					this.editedAmount = null;
					this.editMode = false;
					row.toggleDetails();
				})
				.catch(() => {
					this.$snotify.error('Error updating charge.');
					Object.assign(charge, this.beforeEditingCharge);
					this.beforeEditingCharge = null;
					this.editedAmount = null;
					this.editMode = false;
					row.toggleDetails();
				});
		},
	},
	created() {
		this.fetchCharges();
	},
};
</script>
